import React, { MouseEventHandler } from 'react'
import cns from 'classnames'
import { ReactSVG } from 'react-svg'

interface Props {
  label: string
  href: string
  type?: 'default' | 'icon' | 'social' // default | icon | social
  isLarge?: boolean
  icon?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

const CustomLink: React.FC<Props> = ({
  label,
  href,
  type = 'default',
  isLarge = false,
  icon = 'x',
  onClick
}) => {
  if (type === 'icon') {
    return (
      <a href={href} className={cns('link _icon', { _large: isLarge })}>
        <ReactSVG src={`/i/svg/${icon}.svg`} wrapper="span" />
        <span>{label}</span>
      </a>
    )
  }

  if (type === 'social') {
    return (
      <a
        href={href}
        className={cns('link _social', { _large: isLarge })}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        <ReactSVG src={`/i/svg/${icon}.svg`} wrapper="span" />
        <span>{label}</span>
      </a>
    )
  }

  return (
    <a
      href={href}
      className={cns('link _underline', {
        _large: isLarge
      })}
    >
      {label}
    </a>
  )
}

export default CustomLink

// -
//         const defaultProps = {
//             label: 'Link',
//             href: "#",
//             type: 'default', // default | icon | social
//             isLarge: false,
//             icon: 'link',
//             attributes: {},
//         }
//         const options = {...defaultProps, ...props}

//     if (options.type === 'default')
//         a.link(href=options.href class={'_large': options.isLarge})&attributes(options.attributes)= options.label

//     if (options.type === 'icon')
//         a.link._icon(href=options.href class={'_large': options.isLarge})&attributes(options.attributes)
//             +sprite(options.icon)
//             | #{options.label}

//     if (options.type === 'social')
//         a.link._social(href=options.href)&attributes(options.attributes)
//             span
//                 +sprite(options.icon)
//             | #{options.label}
